<template>
  <div
    class="relative overflow-hidden flex justify-center bg-gray-200 w-full xl:h-150"
    :class="{'h-128': image === null}">
    <template v-if="image !== null">
      <template v-if="typeof image?.id === 'string'">
        <figure class="aspect-w-16 aspect-h-9 w-full">
          <img
            class="aspect-video object-cover"
            :src="image.urls.regular"
            :alt="image.description">
        </figure>
      </template>
      <template v-else>
        <figure
          v-if="image?.mime_type.includes('image/')"
          class="aspect-w-16 aspect-h-9 w-full">
          <blur-hash
            v-if="image && image_crop"
            :hash="image.custom_properties?.blur_hash"
            :src="image_crop.url"
            :alt="image.custom_properties?.description ?? image.name"
            class="aspect-video object-cover" />
          <blur-hash
            v-else-if="image"
            :hash="image.custom_properties?.blur_hash"
            :src="image.original_url"
            :alt="image.custom_properties?.description ?? image.name"
            class="aspect-video object-cover" />
        </figure>
        <video
          v-else-if="image?.mime_type.includes('video/')"
          playsinline
          autoplay
          muted
          loop
          class="w-full object-cover"
          :src="image.original_url"
          :type="image.mime_type">
          Your browser does not support the video tag.
        </video>
        <div
          v-else
          class="flex w-full flex-col justify-center items-center pointer-events-none bg-indigo-100 text-indigo-700 object-cover group-hover:opacity-75">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="w-12 h-12">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z" />
          </svg>
          <span>Unknown media type</span>
        </div>
      </template>
    </template>
    <div
      v-if="image !== null"
      class="absolute top-1/2 w-full h-1/2 bg-gradient-to-b from-transparent to-black opacity-75">
      <!-- Gradient overlay -->
    </div>
    <div class="absolute top-0 left-0 text-white text-4xl w-full px-5 lg:px-20 py-10">
      <div class="w-full max-w-7xl mx-auto">
        Logo
      </div>
    </div>
    <div class="absolute bottom-20 right-0 w-full p-20">
      <div class="max-w-7xl mx-auto">
        <media-select-single
          :selected="image"
          :settings="{
            proposal: {
              name: 'Current Proposal',
              get: route('api.proposal.media.index', {proposal: proposal.id}),
              upload: route('api.proposal.media.store', {proposal: proposal.id})
            }
          }"
          :default_search="proposal.places[0].name"
          :cropable="true"
          :coordinates="image_crop ? image_crop.coordinates : null"
          @update="updateMedia"
          @crop="cropped" />

        <div class="flex flex-col space-y-6 text-white w-2/3 lg:w-1/3">
          <editable-input-field
            v-model="form.title"
            size="xl"
            :transparent="true" />
          <editable-input-field
            v-model="form.subtitle"
            :transparent="true" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  onMounted, ref,
} from 'vue';
import EditableInputField from '@/ComponentsDeprecated/Proposal/EditableInputField';
import MediaSelectSingle from '@/Components/Media/MediaPickerSingle.vue';
import BlurHash from '@/ComponentsDeprecated/BlurHash';

const image = ref(null);
const image_crop = ref(null);

const props = defineProps({
  form: {
    type: Object,
    required: true,
  },
  proposal: {
    type: Object,
    required: true,
  },
});

function updateMedia(media) {
  image.value = media;
  props.form.media_id = media.id;
}
function cropped(data) {
  // if(image_crop.value && image_crop.value.filename) {
  //   console.log('deleting ' + image_crop.value.filename)
  //   axios.delete(route('api.media.crop.destroy', {media: image.value.id, filename: image_crop.value.filename}));
  // }
  image_crop.value = data;
  props.form.media_crop = data;
}

onMounted(() => {
  image.value = props.proposal.image ?? null;
  image_crop.value = props.proposal.media_crop;
});
</script>
